import { sendAnalytics } from 'shared/utils/analytics';

export const trackBannerClick = () =>
  sendAnalytics({ category: 'CardHS', action: 'Click', label: 'show_history_offers' });
